module.exports = __webpack_public_path__ + "static/img/promo_order_4.ff0af4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promo_order_4.png
// module id = j1zz
// module chunks = 0